var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#FF6969"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2241 27C14.2241 28.1 15.1241 29 16.2241 29H24.2241C25.3241 29 26.2241 28.1 26.2241 27V17C26.2241 15.9 25.3241 15 24.2241 15H16.2241C15.1241 15 14.2241 15.9 14.2241 17V27ZM17.2241 17H23.2241C23.7741 17 24.2241 17.45 24.2241 18V26C24.2241 26.55 23.7741 27 23.2241 27H17.2241C16.6741 27 16.2241 26.55 16.2241 26V18C16.2241 17.45 16.6741 17 17.2241 17ZM23.7241 12L23.0141 11.29C22.8341 11.11 22.5741 11 22.3141 11H18.1341C17.8741 11 17.6141 11.11 17.4341 11.29L16.7241 12H14.2241C13.6741 12 13.2241 12.45 13.2241 13C13.2241 13.55 13.6741 14 14.2241 14H26.2241C26.7741 14 27.2241 13.55 27.2241 13C27.2241 12.45 26.7741 12 26.2241 12H23.7241Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5c0095c79f998beee183249abaf4e99f.svg";
export { ForwardRef as ReactComponent };